import {
  booleanAttribute,
  Component,
  computed,
  HostBinding,
  input,
  output,
} from '@angular/core';

type ButtonType = 'solid' | 'secondary' | 'text';
type ButtonAction = 'default' | 'positive' | 'negative';
type ButtonSeverity =
  | 'success'
  | 'info'
  | 'warn'
  | 'danger'
  | 'help'
  | 'primary'
  | 'secondary'
  | 'contrast'
  | null
  | undefined;
@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  buttonType = input<ButtonType>('solid');
  buttonAction = input<ButtonAction>('default');
  disabled = input(false, {
    transform: booleanAttribute,
  });
  fullSize = input(false, {
    transform: booleanAttribute,
  });
  link = input(false, {
    transform: booleanAttribute,
  });
  label = input<string>();
  actionType = input<string>('submit');

  severity = computed((): ButtonSeverity => {
    const actions = this.buttonAction();
    const severityMap: Record<ButtonAction, ButtonSeverity> = {
      default: 'secondary',
      positive: 'success',
      negative: 'danger',
    };

    if (this.isVariantText()) {
      return 'primary';
    }

    return severityMap[actions] ?? 'primary';
  });
  isVariantSolid = computed(() => this.buttonType() === 'solid');
  isVariantOutlined = computed(() => this.buttonType() === 'secondary');
  isVariantText = computed(() => this.buttonType() === 'text');
  variant = computed(() => {
    if (this.isVariantOutlined()) return 'outlined';
    if (this.isVariantText()) return 'text';
    return undefined;
  });

  buttonClass = computed(() => {
    if (this.isVariantText()) return 'no-hover-effect';
    if (this.isVariantOutlined() && this.buttonAction() === 'negative')
      return 'no-border';
    return '';
  });

  handleClick = output<MouseEvent>();

  emitClick($event: MouseEvent) {
    this.handleClick.emit($event);
  }

  @HostBinding('class.fullSize')
  get isFullSize() {
    return this.fullSize();
  }
}
